/**
 * Toast - Composant pour afficher des notifications temporaires
 *
 * Types:
 * - success: Succès (vert)
 * - error: Erreur (rouge)
 * - warning: Avertissement (orange)
 * - info: Information (bleu)
 */

import React, { useEffect } from 'react';
import './Toast.css';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastProps {
  id: string;
  type: ToastType;
  title?: string;
  message: string;
  duration?: number; // En millisecondes (défaut: 5000)
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({
  id,
  type,
  title,
  message,
  duration = 5000,
  onClose
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  const getIcon = (): string => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return 'ℹ️';
    }
  };

  return (
    <div className={`toast toast-${type}`} onClick={() => onClose(id)}>
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-content">
        {title ? (
          <>
            <div className="toast-title">{title}</div>
            <div className="toast-message">{message}</div>
          </>
        ) : (
          <div className="toast-title">{message}</div>
        )}
      </div>
      <button className="toast-close" onClick={() => onClose(id)}>
        ×
      </button>
    </div>
  );
};

export default Toast;
